<template>
  <div class="slider">
    <af-h4 class="slider-title">
      <slot></slot>
    </af-h4>

    <div class="slider-values">
      <span v-if="isMinValue">0 år</span>
      <span v-else>{{ minValue }} år</span>
      <span v-if="isMaxValue">över {{ maxValue }} år</span>
      <span v-else>{{ maxValue }} år</span>
    </div>

    <div class="vue-nouislider" :id="sliderId"></div>

    <div v-if="showButton" class="slider__button">
      <af-button @clicked="click(minValue, maxValue)" buttonStyle="primary" lowercase>
        Lägg till
      </af-button>
    </div>

    <transition name="fade">
      <div v-if="isMinValue && !showButton" class="slider__information">
        <icon class="slider__information-icon"
        link
        type="info-circle"></icon>
        <span>Valet inkluderar kandidater som angett yrket som ett yrkesönskemål.</span>
      </div>
    </transition>
  </div>
</template>

<script>
import noUiSlider from 'nouislider'
import Icon from '@/components/Icon'
import AfH4 from '@/components/AfH4'
import AfButton from '@/components/Button/Button'

export default {
  name: 'nouislider',

  components: {
    Icon,
    AfButton,
    AfH4
  },

  props: {
    showButton: Boolean,
    config: {
      type: Object,
      required: true
    },
    values: {
      type: Array,
      required: true
    },
    id: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      slider: null,
      maxValue: 0,
      minValue: 0,
      initValues: []
    }
  },

  mounted() {
    this.minValue = this.values[0]
    this.maxValue = this.values[1]
    this.initValues = [...this.values]

    this.slider = document.getElementById(this.sliderId)
    this.config.start = this.values.map(value => parseInt(value, 10))
    noUiSlider.create(this.slider, this.config)

    this.slider.noUiSlider.on('update', this.updateValue)

    this.slider.noUiSlider.on('change', newValues => {
      this.$emit('newValueSet', newValues)
    })
  },

  computed: {
    sliderId() {
      return this.id === undefined ? this.uniqueId() : this.id
    },
    isMaxValue() {
      return parseInt(this.maxValue, 10) === this.config.range.max[0]
    },
    isMinValue() {
      return parseInt(this.minValue, 10) === this.config.range.min[0]
    }
  },

  methods: {
    updateValue: function(value, handle) {
      this.$set(this.values, handle, value[handle])
      this.minValue = parseInt(value[0], 10)
      this.maxValue = parseInt(value[1], 10)
    },

    uniqueId: function() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1)
      }
      return 'vue-nouislider-' + s4() + s4()
    },

    click(min, max) {
      const years = [
        {
          modifier: 'gt',
          years: min
        },
        {
          modifier: 'lt',
          years: max
        }
      ]

      this.$emit('clickedSliderButton', years)
    }
  }
}
</script>

<style lang="postcss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 200ms, transform 200ms;
}
.fade-enter,
.fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.vue-nouislider {
  margin: var(--spacing-medium) var(--spacing-half);
}

.slider {
  background-color: var(--color-iron);
  border-radius: 4px;
  padding: var(--spacing-medium);
}
.slider-title {
  margin-bottom: var(--spacing-medium) !important;
  text-align: center;
}
.slider-values {
  display: flex;
  justify-content: space-between;
}

.slider__button {
  display: flex;
  margin-top: var(--spacing-large);
  justify-content: center;
}

.slider__information {
  display: flex;
  margin-top: 40px;
}

.slider__information-icon {
  margin-right: var(--spacing-half);
}

/*! nouislider - 10.1.0 - 2017-07-28 13:09:54 */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
  -ms-touch-action: none;
  touch-action: none;
  -ms-user-select: none;
  -moz-user-select: none;
  user-select: none;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.noUi-target {
  position: relative;
  direction: ltr;
}
.noUi-base {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}
.noUi-connect {
  position: absolute;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
}
.noUi-origin {
  position: absolute;
  height: 0;
  width: 0;
}
.noUi-handle {
  position: relative;
  z-index: 1;
}
.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  -webkit-transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;
  transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;
}
.noUi-state-drag * {
  cursor: inherit !important;
}
.noUi-base,
.noUi-handle {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
.noUi-horizontal {
  height: 3px;
}
.noUi-horizontal .noUi-handle {
  border-radius: 100%;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.15);
  top: -13px;
  left: -13px;
  width: 26px;
  height: 26px;
}
.noUi-vertical {
  width: 18px;
}
.noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  left: -6px;
  top: -17px;
}
.noUi-target {
  background: var(--color-silver-chalice);
  border-radius: 4px;
  border: 1px solid #d3d3d3;
  box-shadow: inset 0 1px 1px #f0f0f0, 0 3px 6px -5px #bbb;
}
.noUi-connect {
  background: var(--color-mine-shaft);
  border-radius: 0;
  box-shadow: none;
  -webkit-transition: background 450ms;
  transition: background 450ms;
}
.noUi-draggable {
  cursor: ew-resize;
}
.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}
.noUi-handle {
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  cursor: default;
  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ebebeb, 0 3px 6px -3px #bbb;
}
.noUi-active {
  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ddd, 0 3px 6px -3px #bbb;
}
.noUi-handle:after,
.noUi-handle:before {
  content: '';
  display: block;
  position: absolute;
  height: 14px;
  width: 1px;
  background: var(--color-mine-shaft);
  left: 13px;
  top: 5px;
}

.noUi-handle:after {
  left: 9px;
}

.noUi-vertical .noUi-handle:after,
.noUi-vertical .noUi-handle:before {
  width: 14px;
  height: 1px;
  left: 6px;
  top: 14px;
}
.noUi-vertical .noUi-handle:after {
  top: 17px;
}
[disabled] .noUi-connect {
  background: #b8b8b8;
}
[disabled] .noUi-handle,
[disabled].noUi-handle,
[disabled].noUi-target {
  cursor: not-allowed;
}
.noUi-pips,
.noUi-pips * {
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.noUi-pips {
  position: absolute;
  color: #999;
}
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}
.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}
.noUi-marker {
  position: absolute;
  background: #ccc;
}
.noUi-marker-large,
.noUi-marker-sub {
  background: #aaa;
}
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}
.noUi-value-horizontal {
  -webkit-transform: translate3d(-50%, 50%, 0);
  transform: translate3d(-50%, 50%, 0);
}
.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}
.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}
.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}
.noUi-value-vertical {
  -webkit-transform: translate3d(0, 50%, 0);
  transform: translate3d(0, 50%, 0);
  padding-left: 25px;
}
.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}
.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}
.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}
.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.noUi-target {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/AfRange.vue